import { Component, HostBinding, input } from '@angular/core';
import { Button } from '../button/button';
import type { OpenCloseItem, SummaryLateralActionIcon, SummaryLateralModuleName } from '@appTypes';
import { Icon } from '../icon/icon';
import { OpenClose } from '../open-close/open-close';
import { Spinner } from '../spinner/spinner';
import { Card } from '@directives/card';
import { SummaryLateralPanel } from './summary-lateral-panel/summary-lateral-panel';
import { cssValue } from '@helpers';

export type SummaryInputData = {
  title: string;
  subtitle: string;
};

@Component({
  selector: 'app-summary-lateral',
  standalone: true,
  imports: [Button, Icon, OpenClose, Spinner, SummaryLateralPanel, Card],
  templateUrl: './summary-lateral.html',
  styleUrl: './summary-lateral.scss',
})
export class SummaryLateral {

  // Inputs
  $moduleName = input.required<SummaryLateralModuleName>({ alias: 'moduleName' });
  $show = input.required<boolean>({ alias: 'show' });
  $data = input.required<SummaryInputData | null>({ alias: 'data' });
  $actionIcons = input.required<SummaryLateralActionIcon[]>({ alias: 'actionIcons' });
  $openCloseItems = input.required<(OpenCloseItem)[]>({ alias: 'openCloseItems' });
  $loading = input<boolean>(false, { alias: 'loading' });
  $width = input<string>('340px', { alias: 'width' });
  $marginLeft = input<string | undefined>('--margin-extra-large', { alias: 'marginLeft' });
  $marginRight = input<string | undefined>(undefined, { alias: 'marginRight' });

  // Bindings
  @HostBinding('style.width')
  get width(): string { return !this.$show() ? '0' : this.$width(); }

  @HostBinding('style.marginLeft')
  get hostMarginLeft(): string | undefined { return !this.$show() ? '0' : cssValue(this.$marginLeft()); }

  @HostBinding('style.marginRight')
  get hostMarginRight(): string | undefined { return !this.$show() ? '0' : cssValue(this.$marginRight()); }
}
